module.exports = __webpack_public_path__ + "static/media/material-ui.2fadd2a1.svg";